export * from './FaceAHappyIcon';
export * from './FaceAHappyIcon16Light';
export * from './FaceAHappyIcon16Regular';
export * from './FaceAHappyIcon16Solid';
export * from './FaceAHappyIcon20Light';
export * from './FaceAHappyIcon20Regular';
export * from './FaceAHappyIcon20Solid';
export * from './FaceAHappyIcon24Regular';
export * from './FaceAHappyIcon24Solid';
export * from './FaceAHappyIcon32Regular';
export * from './FaceAHappyIcon64Regular';
